import { GridColDef } from "@mui/x-data-grid-pro";
import { DefaultSwitchInput } from "../../../../../../common/components/default_switch_input";

/**
 * GenerateCategoriaColumnDefinition
 */

type Props = {
  onActionCategoriaChange: (idCategoriaAssistencia: number, ativo: boolean) => void;
};

export const GenerateCategoriaColumnDefinition = ({
  onActionCategoriaChange,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "",
      width: 125,
      minWidth: 125,
      sortable: false,
      align: 'center',
      valueGetter: (_, row) => ([row['idCategoriaAssistencia'], row['ativo']]),
      renderCell: ({ value: [idCategoriaAssistencia, ativo] }) => (
        <div className="w-full flex flex-row justify-center items-center">
          <DefaultSwitchInput
            name={`cat-sel-${idCategoriaAssistencia}`}
            activeLabel='Sim'
            inactiveLabel='Não'
            value={ativo}
            onChange={e => onActionCategoriaChange(idCategoriaAssistencia, e)}
          />
        </div>
      )
    },
    {
      field: "nomeCategoria",
      filterable: false,
      headerName: "Categoria",
      flex: 1,
      minWidth: 80,
      sortable: false,
      align: 'left',
    },
  ];
}